import React from "react";
import { Card } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import { brand } from "../StyledComponents/theme";

const useStyles = makeStyles({
  interactive: {
    transition: "box-shadow 200ms ease, transform 200ms ease",
    "&:hover": {
      boxShadow: brand.cardShadowHover,
      transform: "translateY(-2px)",
    },
  },
});

/**
 * Standard content card. Radius/shadow come from the theme; pass
 * `interactive` for the hover lift on clickable cards.
 */
const AppCard = ({ interactive, className, children, ...props }) => {
  const classes = useStyles();
  const combined = [interactive ? classes.interactive : "", className || ""]
    .join(" ")
    .trim();

  return (
    <Card className={combined || undefined} {...props}>
      {children}
    </Card>
  );
};

export default AppCard;
